<template>
  <div class="surveillance">
    <!-- filter popover -->
    <el-popover
      ref="filterpopover"
      placement="bottom-end"
      width="300"
      trigger="click">
        <el-row>
          <el-col :span="12">Precautions:</el-col>
            <el-col :span="12">
              <el-switch
                v-model="allFilters.precaution"
                on-text="YES"
                off-text="NO"
                on-color="#13ce66"
                off-color="#ff4949">
              </el-switch>
            </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">Organisms:</el-col>
            <el-col :span="12">
              <el-switch
                v-model="allFilters.organism"
                on-text="YES"
                off-text="NO"
                on-color="#13ce66"
                off-color="#ff4949">
              </el-switch>
            </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">Resolutions:</el-col>
            <el-col :span="12">
              <el-switch
                v-model="allFilters.resolution"
                on-text="YES"
                off-text="NO"
                on-color="#13ce66"
                off-color="#ff4949">
              </el-switch>
            </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">Family Notified:</el-col>
            <el-col :span="12">
              <el-switch
                v-model="allFilters.familyNotified"
                on-text="YES"
                off-text="NO"
                on-color="#13ce66"
                off-color="#ff4949">
              </el-switch>
            </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">Next Of Kin Notified:</el-col>
            <el-col :span="12">
              <el-switch
                v-model="allFilters.nextOfKinNotified"
                on-text="YES"
                off-text="NO"
                on-color="#13ce66"
                off-color="#ff4949">
              </el-switch>
            </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">Physician Notified:</el-col>
            <el-col :span="12">
              <el-switch
                v-model="allFilters.physicianNotified"
                on-text="YES"
                off-text="NO"
                on-color="#13ce66"
                off-color="#ff4949">
              </el-switch>
            </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">Staff:</el-col>
            <el-col :span="12">
              <el-switch
                v-model="allFilters.staffOrRes"
                on-text="YES"
                off-text="NO"
                on-color="#13ce66"
                off-color="#ff4949">
              </el-switch>
            </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">First Name:</el-col>
            <el-col :span="12">
              <el-switch
                v-model="allFilters.firstName"
                on-text="YES"
                off-text="NO"
                on-color="#13ce66"
                off-color="#ff4949">
              </el-switch>
            </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">Last Name:</el-col>
            <el-col :span="12">
              <el-switch
                v-model="allFilters.lastName"
                on-text="YES"
                off-text="NO"
                on-color="#13ce66"
                off-color="#ff4949">
              </el-switch>
            </el-col>
        </el-row>
    </el-popover>
    <div class="filter">
      <div class="section-header">
        <el-row><span>Surveillance</span>
          <div class="case-filter">
            <el-button size="mini" v-popover:filterpopover>Add Filters</el-button>
          </div>
        </el-row>
      </div>
      <!-- FILTER -->
      <el-row class="filter-section">
        <label><span class="filter-title-label">Date Range:</span>
        <el-date-picker
          class="filter-section-input"
          label="Date Range"
          v-model="filterDateRange"
          type="daterange"
          placeholder="Date Range"
          format="dd-MM-yyyy" range-separator=" ~ "
          :picker-options="pickerOptions"
          :clearable="false"
          small
          v-on:change="dateRangeUpdated">
          <template slot="prepend">Http://</template>
        </el-date-picker>
        </label>
        <label><span class="filter-title-label">Unit:</span>
        <el-select v-model="selectedUnit" placeholder="Unit" class="filter-section-input" v-on:change="unitUpdated">
          <el-option
          label="All Units"
          :value='0'>
          </el-option>
          <el-option
          v-for="item in units"
          :label="item.displayText"
          :value="item.id">
            <span style="float: left">{{ item.displayText }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
          </el-option>
        </el-select>
        </label>
        <label>
        <span class="filter-title-label">Infection Site:</span>
        <el-select v-model="filteredSite" class="filter-section-input" placeholder="Select Infection Site"
        v-on:change="symptomTypeUpdated">
          <el-option v-for="item in symptomTypes"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
        </label>
        <label v-if="allFilters.origin">
        <span class="filter-title-label">Origin:</span>
        <el-select v-model="selectedOrigin" class="filter-section-input" placeholder="Origin" v-on:change="originUpdated">
          <el-option
          v-for="item in origins"
          :label="item.label"
          :value="item.value">
          </el-option>
        </el-select>
        </label>
        <label>
        <span class="filter-title-label">Status:</span>
        <el-select v-model="selectedStatus" class="filter-section-input" placeholder="Status" v-on:change="confirmStatusUpdated">
          <el-option
            label="All"
            :value='0'>
          </el-option>
          <el-option
            label="Confirmed"
            :value='1'>
          </el-option>
          <el-option
            label="Suspected"
            :value='2'>
          </el-option>
        </el-select>
        </label>
        <label v-if="allFilters.precaution">
        <span class="filter-title-label">Precautions:</span>
        <el-select v-model="selectedPrecautions" class="filter-section-input" placeholder="Precautions" v-on:change="precautionUpdated">
          <el-option
            label="All Precautions"
            :value='0'>
          </el-option>
          <el-option
          v-for="item in precautions"
          :label="item.displayText"
          :value="item.id">
          </el-option>
        </el-select>
        </label>
        <label v-if="allFilters.organism">
        <span class="filter-title-label">Organisms:</span>
        <el-select v-model="selectedOrganisms" class="filter-section-input" placeholder="Not Selected" v-on:change="organismsUpdated">
          <el-option
            label="Not Selected"
            v-bind:value="0">
          </el-option>
          <el-option
            v-for="item in organisms"
            :label="item.name"
            :value="item.id">
          <span style="float: left">{{ item.name }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
          </el-option>
        </el-select>
        </label>
        <label v-if="allFilters.resolution">
         <span class="filter-title-label">Resolution:</span>
        <el-select v-model="selectedResolved" class="filter-section-input" placeholder="Resolution" v-on:change="resolvedUpdated">
          <el-option
            label="All"
            :value='0'>
          </el-option>
          <el-option
            label="Resolved"
            :value='1'>
          </el-option>
          <el-option
            label="Not Resolved"
            :value='2'>
          </el-option>
        </el-select>
        </label>
        <label v-if="allFilters.familyNotified">
        <span class="filter-title-label">Family Notified:</span>
        <el-select v-model="selectedFamilyNotified" class="filter-section-input" placeholder="Family Notified" v-on:change="resolvedUpdated">
          <el-option
            label="All"
            :value='0'>
          </el-option>
          <el-option
            label="Notified"
            :value='1'>
          </el-option>
          <el-option
            label="Not Notified"
            :value='2'>
          </el-option>
        </el-select>
        </label>
        <label v-if="allFilters.nextOfKinNotified">
        <span class="filter-title-label">Next of Kin Notified:</span>
        <el-select v-model="selectedNextOfNotified" class="filter-section-input" placeholder="Next of Kin Notified" v-on:change="resolvedUpdated">
          <el-option
            label="All"
            :value='0'>
          </el-option>
          <el-option
            label="Notified"
            :value='1'>
          </el-option>
          <el-option
            label="Not Notified"
            :value='2'>
          </el-option>
        </el-select>
        </label>
        <label v-if="allFilters.physicianNotified">
        <span class="filter-title-label">Physician Notified:</span>
        <el-select v-model="selectedPhysicianNotified" class="filter-section-input" placeholder="Physician Notified" v-on:change="resolvedUpdated">
          <el-option
            label="All"
            :value='0'>
          </el-option>
          <el-option
            label="Notified"
            :value='1'>
          </el-option>
          <el-option
            label="Not Notified"
            :value='2'>
          </el-option>
        </el-select>
        </label>
        <label v-if="allFilters.staffOrRes">
        <span class="filter-title-label">Client Type:</span>
        <el-select v-model="selectedClientType" class="filter-section-input" placeholder="Client Type" v-on:change="resolvedUpdated">
          <el-option
            label="All"
            :value='0'>
          </el-option>
          <el-option
            label="Resident"
            :value='1'>
          </el-option>
          <el-option
            label="Staff"
            :value='2'>
          </el-option>
        </el-select>
        </label>
        <label v-if="allFilters.firstName">
        <span class="filter-title-label">First Name:</span>
        <el-input placeholder="First Name" v-model="selectedFirstName" icon="search" :on-icon-click="resolvedUpdated"></el-input>
        </label>
        <label v-if="allFilters.lastName">
        <span class="filter-title-label">Last Name:</span>
        <el-input placeholder="Last Name" v-model="selectedLastName" icon="search" :on-icon-click="resolvedUpdated"></el-input>
        </label>
      </el-row>
    </div>
    <!-- New Case Dialog -->
    <el-dialog title="New Case" v-model="newCaseDialogFormVisible">
      <div class="new-case-dialog">
        <el-row>
          <el-col :span="5">Residents:</el-col>
          <el-col :span="16">
            <el-select v-model="newCase.client" filterable placeholder="Not Selected">
              <el-option
                v-for="item in clientList"
                :label="getClientName(item)"
                :value="item.id">
                  <span style="float: left">{{ getClientName(item) }}</span>
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">Symptoms:</el-col>
          <el-col :span="16">
            <el-select v-model="newCase.symptoms" filterable multiple placeholder="Not Selected">
              <el-option
                v-for="item in symptoms"
                :label="item.displayText"
                :value="item.id">
                  <span style="float: left">{{ item.displayText }}</span>
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <div class="dialog-footer">
          <el-button @click="addSymptoms(newCase.client, newCase.symptoms)">Create</el-button>
          <el-button type="primary" @click="newCaseDialogFormVisible = false; this.newCase = { client: null, symptoms: [] }">Close</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- Detail View -->
    <el-dialog :title="clientName(selectedCase)" v-if="selectedCase" v-model="dialogFormVisible" size="large">
      <el-tabs v-model="caseActiveTab" type="card">
        <el-tab-pane label="Case Detail" name="1">
          <surveillance-case-detail
            :caseData="selectedCase"
            :clientData="clients[selectedCase.clientId]"
            :origins="origins"
            :organisms="organisms"
            :treatments="treatments">
          </surveillance-case-detail>
          <div class="dialog-footer">
            <el-button @click="saveSymtomDetail(selectedCase)">Update</el-button>
            <el-button type="primary" @click="dialogFormVisible = false; this.selectedCase = null">Close</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Communication" name="2">
          <surveillance-communication
            :caseData="selectedCase"
            :clientData="clients[selectedCase.clientId]"
            :notes="selectedCase.notes">
          </surveillance-communication>
        </el-tab-pane>
<!--        <el-tab-pane label="Biology" name="3">
          <surveillance-biology
           :organisms="organisms">
          </surveillance-biology>
        </el-tab-pane>
        <el-tab-pane label="Device" name="4">
          <surveillance-device>
          </surveillance-device>
        </el-tab-pane>-->
        <el-tab-pane label="Signs and Symptoms" name="5">
          <surveillance-symptoms
            :caseData="selectedCase">
          </surveillance-symptoms>
          <div class="dialog-footer">
            <el-button @click="saveSymtomDetail(selectedCase)">Update</el-button>
            <el-button type="primary" @click="dialogFormVisible = false; this.selectedCase = null">Close</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Treatment" name="6">
          <surveillance-treatment
            :caseData="selectedCase">
          </surveillance-treatment>
        </el-tab-pane>      
        <el-tab-pane label="Individual" name="7">
          <surveillance-personal-info
            :clientData="clients[selectedCase.clientId]">
          </surveillance-personal-info>
        </el-tab-pane>      
        <el-tab-pane label="Precaution" name="8">
          <surveillance-precaution
            :caseData="selectedCase"
            :precautions="precautions"
            :clientData="clients[selectedCase.clientId]">
          </surveillance-precaution>
        </el-tab-pane>          
      </el-tabs>
    </el-dialog>
    <!-- DETAIL -->
    <!-- LISTING -->
    <div class="section-header">
      <el-row><span>Case Detail - Total: {{ symptomDetailTotal }}</span>
        <div class="case-filter">
            <el-button class="case-export-button" :plain="true" type="primary" size="mini" @click="createNewCase()"> + New Case</el-button>
            <el-button class="case-export-button" :plain="true" type="primary" size="mini" @click="exportExcel()">Export Data</el-button>
            <el-pagination
              small
              layout="prev, pager, next"
              :current-page="symptomDetailPage"
              :page-count="symptomDetailPageTotal"
              v-on:current-change="reloadPage">
            </el-pagination>
        </div>
      </el-row>
    </div>
    <el-table
    v-loading.body="loading"
    :data="cases"
    style="width: 100%"
    v-on:row-click="selectedRow"
    :default-sort = "{prop: 'onSetDate', order: 'descending'}"
    >
      <el-table-column
        fixed
        label=" "
        width="100">
        <template scope="scope">
          <div style="padding: 0.5em;">
          <div :span="4" class="profile-row-photo" v-if="clients[scope.row.clientId]"><img :src="photosUrl(scope.row.clientId)"></div>
          <div :span="4" class="profile-row-photo" v-else><img src="~assets/user.png"></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="Name"
        sortable
        fixed
        width="180">
        <template scope="scope">
          <span v-if="clients[scope.row.clientId]">{{ clientName(scope.row) }}<br />({{clients[scope.row.clientId].patientId}})</span>
          <span v-else>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Gender"
        width="140">
        <template scope="scope">
          <span v-if="scope.row.gender">{{ scope.row.gender }}</span>
          <span v-else>Not Entered</span>
        </template>
      </el-table-column>
      <el-table-column
        label="DOB"
        prop="dateOfBirth"
        width="180">
        <template scope="scope">
          <span v-if="scope.row.dateOfBirth">{{ scope.row.dateOfBirth | moment('DD-MM-YYYY') }}</span>
          <span v-else>Not Entered</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Infection Site"
        width="140">
        <template scope="scope">
          <span class="color-code-label-0" v-if="scope.row.symptomType === 'GI'"></span>
          <span class="color-code-label-2" v-else-if="scope.row.symptomType === 'UTI'"></span>
          <span class="color-code-label-1" v-else></span>
          {{ scope.row.symptomType }}
        </template>
      </el-table-column>
      <el-table-column
        label="Status"
        width="80">
        <template scope="scope">
          <img class="symptom-status-image" :src="statusImage(scope.row)">
        </template>
      </el-table-column>
      <el-table-column
        label="Symptoms"
        min-width="160">
        <template scope="scope">
          <el-tag v-for="d in scope.row.symptoms" :key="d.id" :type="tagType(d)">{{ d.displayText }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="Precautions"
        min-width="160">
        <template scope="scope">
          <div v-if="clients[scope.row.clientId]">
            <el-tag v-for="d in clients[scope.row.clientId].precautionDetails">{{ precautionById(d.precautionId) }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Staff"
        min-width="160">
        <template scope="scope">
          <span v-if="isStaff(clients[scope.row.clientId])">
            Yes
          </span>
          <span v-else>
            No
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Location"
        width="160">
        <template scope="scope">
          {{ unitById(scope.row.unitId) }} / {{ beds[scope.row.bedId] }}
        </template>
      </el-table-column>
      <el-table-column
        label="Origin"
        width="200">
        <template scope="scope">
          {{ originById(scope.row.origin) }}
        </template>
      </el-table-column>
      <el-table-column
        label="Organism"
        width="220">
        <template scope="scope">
          {{ organismById(scope.row.organismId) }}
        </template>
      </el-table-column>
      <el-table-column
        label="Treatment"
        width="220">
        <template scope="scope">
          {{ treatmentById(scope.row.treatmentId) }}
        </template>
      </el-table-column>
      <el-table-column
        label="Resolution"
        width="180">
        <template scope="scope">
          {{ scope.row.resolved }}
        </template>
      </el-table-column>
      <el-table-column
        label="Family Notified"
        width="180">
        <template scope="scope">
          {{ scope.row.familyNotified }}
        </template>
      </el-table-column>
      <el-table-column
        label="Next of Kin Notified"
        width="180">
        <template scope="scope">
          {{ scope.row.nextOfNotified }}
        </template>
      </el-table-column>
      <el-table-column
        label="Physician Notified"
        width="180">
        <template scope="scope">
          {{ scope.row.physicianNotified }}
        </template>
      </el-table-column>
      <el-table-column
        label="Updated"
        prop="updated"
        width="180">
        <template scope="scope">
          {{ scope.row.updated | moment('DD-MM-YYYY') }}
        </template>
      </el-table-column>
      <el-table-column
        label="Created"
        prop="created"
        width="180">
        <template scope="scope">
          {{ scope.row.created | moment('DD-MM-YYYY') }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="Onset Date"
        prop="onSetDate"
        sortable
        width="140">
        <template scope="scope">
          {{ scope.row.onSetDate | moment('DD-MM-YYYY') }}
        </template>
      </el-table-column>
  </div>
</template>

<script>
import auth from '../auth'

import moment from 'moment'
import { Loading } from 'element-ui'
import SurveillanceCaseDetail from '../components/SurveillanceCaseDetail'
import SurveillanceCommunication from '../components/SurveillanceCommunication'
import SurveillanceBiology from '../components/SurveillanceBiology'
import SurveillanceDevice from '../components/SurveillanceDevice'
import SurveillanceSymptoms from '../components/SurveillanceSymptoms'
import SurveillanceTreatment from '../components/SurveillanceTreatment'
import SurveillancePersonalInfo from '../components/SurveillancePersonalInfo'
import SurveillancePrecaution from '../components/SurveillancePrecaution'

module.exports = {
  name: 'surveillance',
  components: {
    'surveillance-case-detail': SurveillanceCaseDetail,
    'surveillance-communication': SurveillanceCommunication,
    'surveillance-biology': SurveillanceBiology,
    'surveillance-device': SurveillanceDevice,
    'surveillance-symptoms': SurveillanceSymptoms,
    'surveillance-treatment': SurveillanceTreatment,
    'surveillance-personal-info': SurveillancePersonalInfo,
    'surveillance-precaution': SurveillancePrecaution
  },
  data: function () {
    return {
      filterSelectionVisible: false,
      loading: true,
      currentDate: new Date(),
      cases: [],
      precautions: [],
      beds: {},
      symptomTypes: [],
      symptoms: [],
      searchNameInput: '',
      clients: {},
      clientList: [],
      clientService: {},
      origins: [{
        value: 0,
        label: 'All'
      },
      {
        value: 'HAI',
        label: 'HAI'
      },
      {
        value: 'Community Acquired',
        label: 'Community Acquired'
      }],
      statusImageMap: {
        'GI': 'bug2',
        'UTI': 'bug3',
        'Respiratory': 'bug1'
      },
      allFilters: {
        dateRange: true,
        unit: true,
        infSite: true,
        status: true,
        origin: true,
        precaution: false,
        organism: false,
        resolution: false,
        familyNotified: false,
        nextOfKinNotified: false,
        physicianNotified: false,
        staffOrRes: false,
        firstName: false,
        lastName: false
      },
      caseActiveTab: '1',
      selectedCase: null,
      selectedClient: null,
      selectedUnit: 0,
      selectedOrigin: 0,
      selectedStatus: 0,
      selectedPrecautions: 0,
      selectedOrganisms: 0,
      selectedResolved: 0,
      selectedFamilyNotified: 0,
      selectedNextOfNotified: 0,
      selectedPhysicianNotified: 0,
      selectedClientType: 0,
      selectedFirstName: '',
      selectedLastName: '',
      dialogFormVisible: false,
      newCaseDialogFormVisible: false,
      newCase: {
        client: null,
        symptoms: []
      },
      symptomDetailPage: 1,
      symptomDetailPageSize: 10,
      symptomDetailPageTotal: 0,
      symptomDetailTotal: 0,
      filterDateRange: '',
      filteredSite: {},
      filterPeriods: 'week',
      filterSymptomTypes: [],
      organisms: [],
      treatments: [],
      units: [],
      graphPeriodFilter: 'By Week',
      graphDisplayFilter: 'By Infection Site',
      pickerOptions: {
        shortcuts: [{
          text: 'Last week',
          onClick (picker) {
            const end = moment().weekday(-1).toDate()
            const start = moment().weekday(-7).toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Last month',
          onClick (picker) {
            const lastMonth = moment().subtract(1, 'months')
            const end = lastMonth.endOf('month').toDate()
            const start = lastMonth.startOf('month').toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Last year',
          onClick (picker) {
            const lastYear = moment().subtract(1, 'years')
            const end = lastYear.endOf('year').toDate()
            const start = lastYear.startOf('year').toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Current week',
          onClick (picker) {
            const end = moment().weekday(6).toDate()
            const start = moment().weekday(0).toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Current month',
          onClick (picker) {
            const lastMonth = moment()
            const end = lastMonth.endOf('month').toDate()
            const start = lastMonth.startOf('month').toDate()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Current year',
          onClick (picker) {
            const end = moment().endOf('year').toDate()
            const start = moment().startOf('year').toDate()
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  methods: {
    buildParam: function () {
      var after = this.filterDateRange[0]
      var before = this.filterDateRange[1]

      var rUrl = 'start=' + after + '&end=' + before
      rUrl = rUrl + '&types=' + this.filterSymptomTypes

      if (this.selectedOrigin !== 0) {
        rUrl = rUrl + '&origin=' + this.selectedOrigin
      }

      if (this.selectedStatus !== 0) {
        rUrl = rUrl + '&confirmed=' + (this.selectedStatus === 1 ? 'true' : 'false')
      }

      if (this.selectedPrecautions !== 0) {
        rUrl = rUrl + '&precaution=' + this.selectedPrecautions
      }

      if (this.selectedOrganisms !== 0) {
        rUrl = rUrl + '&organism=' + this.selectedOrganisms
      }

      if (this.selectedResolved !== 0) {
        rUrl = rUrl + '&resolved=' + (this.selectedResolved === 1 ? 'true' : 'false')
      }

      if (this.selectedFamilyNotified !== 0) {
        rUrl = rUrl + '&familyNotified=' + (this.selectedFamilyNotified === 1 ? 'true' : 'false')
      }

      if (this.selectedNextOfNotified !== 0) {
        rUrl = rUrl + '&nextOfNotified=' + (this.selectedNextOfNotified === 1 ? 'true' : 'false')
      }

      if (this.selectedPhysicianNotified !== 0) {
        rUrl = rUrl + '&physicianNotified=' + (this.selectedPhysicianNotified === 1 ? 'true' : 'false')
      }

      if (this.selectedClientType !== 0) {
        rUrl = rUrl + '&clientType=' + (this.selectedClientType === 1 ? 'Client' : 'Staff')
      }

      if (this.selectedFirstName !== '') {
        rUrl = rUrl + '&firstName=' + this.selectedFirstName
      }

      if (this.selectedLastName !== '') {
        rUrl = rUrl + '&lastName=' + this.selectedLastName
      }

      return rUrl
    },
    loadCases: function () {
      if (!this.loading) {
        this.loading = true
      }
      var vm = this
      var unitId = this.selectedUnit || 0

      var rUrl = window.CONFIG.api + '/symptomDetail/unit/' + unitId + '/page/' + (vm.symptomDetailPage - 1) + '?size=' + vm.symptomDetailPageSize + '&' + this.buildParam()

      this.$http.get(rUrl)
      .then(response => {
        if (response.body && response.body['content'].length > 0) {
          var cases = response.body['content'] // response.body['_embedded'].symptomDetails
          var callbackCounter = 0

          vm.symptomDetailPageTotal = response.body['totalPages']
          vm.symptomDetailTotal = response.body['totalElements']
          cases.forEach(function (c) {
            if (c.origin == null) {
              c.origin = 'Not Selected'
            }
            c.symptoms.sort(function (a, b) {
              return a.colorCode > b.colorCode
            })
            vm.loadImage(c, function () {
              callbackCounter++
              if (callbackCounter >= cases.length) {
                vm.cases = cases
              }
            })
          })
        } else {
          console.log('no content')
          vm.cases = []
        }

        vm.$nextTick(function () {
          vm.loading = false
        })
      }, response => {
        // error callback
      })

      vm.$watch('graphPeriodFilter', function (val) {
        if (vm.graphPeriodFilter === 'By Year') {
          vm.filterPeriods = 'year'
        } else if (vm.graphPeriodFilter === 'By Quarter') {
          vm.filterPeriods = 'quarter'
        } else if (vm.graphPeriodFilter === 'By Month') {
          vm.filterPeriods = 'month'
        } else if (vm.graphPeriodFilter === 'By Week') {
          vm.filterPeriods = 'week'
        }
      })
    },
    clientName: function (symptomDetail) {
      var clientData = this.clients[symptomDetail.clientId]

      return this.getClientName(clientData)
    },
    getClientName: function (clientData) {
      var firstName = clientData.firstName ? clientData.firstName + ' ' : ''
      var middleName = clientData.middleName ? clientData.middleName + ' ' : ''
      var lastName = clientData.lastName ? clientData.lastName : ''

      return firstName + middleName + lastName
    },
    loadOrganisms: function () {
      var vm = this
      this.$http.get(window.CONFIG.api + '/organisms/')
      .then(response => {
        vm.organisms = response.body['_embedded'].organisms
        vm.loadPrecautions()
      }, response => {
        // error callback
      })
    },
    loadPrecautions: function () {
      var vm = this
      this.$http.get(window.CONFIG.api + '/precautions/')
      .then(response => {
        vm.precautions = response.body['_embedded'].precautions
        vm.loadTreatments()
      }, response => {
        // error callback
      })
    },
    loadTreatments: function () {
      var vm = this
      this.$http.get(window.CONFIG.api + '/treatments/')
      .then(response => {
        vm.treatments = response.body['_embedded'].treatments
        vm.loadCases()
      }, response => {
        // error callback
      })
    },
    loadUnits: function () {
      var vm = this
      this.$http.get(window.CONFIG.api + '/units', {
        headers: {
          'Authorization': 'Bearer ' + auth.getToken()
        }
      })
      .then(response => {
        vm.units = response.body['_embedded'].units
        vm.graphConfig = { units: vm.units }

        if (vm.selectedUnit === null && vm.units && vm.units.length > 0) {
          vm.selectedUnit = vm.units[0].value
        }

        vm.units.forEach(function (u) {
          vm.loadRooms(u)
        })
      })
    },
    loadRooms: function (unit) {
      var vm = this
      this.$http.get(window.CONFIG.api + '/units/' + unit.id + '/rooms')
      .then(response => {
        // console.log(response)
        var rooms = response.body['_embedded'].rooms
        rooms.forEach(function (room) {
          var beds = room.beds
          beds.forEach(function (bed) {
            vm.beds[bed.id] = room.displayText + '-' + bed.displayText
            // console.log(unit.displayText + '/' + room.displayText + '-' + bed.displayText)
          })
        })

        vm.loadSymptomTypes()
      }, response => {

      })
    },
    loadSymptomTypes: function () {
      var vm = this

      // http://localhost:8080/symptoms/classtypes
      this.$http.get(window.CONFIG.api + '/symptoms/classtypes')
      .then(response => {
        vm.symptomTypes = []
        var newTypes = response.body
        if (newTypes && newTypes.length > 0) {
          vm.symptomTypes.push({'text': 'All Infection Site', 'value': 0})
          for (var i = 0; i < newTypes.length - 1; i++) {
            var s = {}
            s.text = newTypes[i]
            s.value = i + 1
            vm.symptomTypes.push(s)
          }
          vm.filteredSite = vm.symptomTypes[0].value
          console.log(JSON.stringify(newTypes, ' ', 2))
        }
        vm.loadSymptoms()
      })
    },
    loadSymptoms: function () {
      var vm = this

      this.$http.get(window.CONFIG.api + '/symptoms')
      .then(response => {
        vm.symptoms = response.body['_embedded'].symptoms
        vm.loadOrganisms()
      })
    },
    nameFilter: function (cases) {
      var vm = this
      return cases.filter(function (detail) {
        return detail.name.toLowerCase().includes(vm.searchNameInput.toLowerCase())
      })
    },
    reloadPage: function (page) {
      if (this.symptomDetailPage !== page) {
        this.symptomDetailPage = page
        this.loadCases()
      }
    },
    loadImage: function (detail, callback) {
      var vm = this
      if (this.clients[detail.clientId] || this.clients[detail.clientId] === false) {
        callback()
        return
      }
      this.clients[detail.clientId] = false
      this.$http.get(window.CONFIG.api + '/clients/' + detail.clientId)
      .then(response => {
        vm.$set(vm.clients, detail.clientId, response.body)
        vm.$forceUpdate()
        callback()
      }, response => {
        // error
        callback()
      })
    },
    statusImage: function (detail) {
      if (detail.symptomType) {
        var filename = this.statusImageMap[detail.symptomType]
        if (!detail.confirmed) {
          filename = filename + 's'
        }
        return '/static/' + filename + '.png'
      }
    },
    tagType: function (type) {
      if (type.colorCode === '0') {
        return 'success'
      } else if (type.colorCode === '1') {
        return 'primary'
      } else if (type.colorCode === '2') {
        return 'warning'
      } else if (type.colorCode === '3') {
        return 'danger'
      }
      return 'gray'
    },
    selectedRow: function (row, event, column) {
      this.selectedCase = row
      this.selectedClient = this.clients[row.clientId]

      console.log(this.selectedCase.clientId)
      var vm = this
      vm.$nextTick(function () {
        vm.caseActiveTab = '1'
        vm.dialogFormVisible = true
        console.log(vm.caseActiveTab)
      })
    },
    dateRangeUpdated: function (value) {
      // console.log(value)
      if (!value) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)

        this.filterDateRange = [start, end]
      }

      this.loadCases()
    },
    unitUpdated: function (value) {
      this.loadCases()
    },
    originUpdated: function (value) {
      if (value === 0) {
        this.filterOrigin = null
      } else {
        this.filterOrigin = value
      }
      console.log('originUpdated:' + value)
      this.loadCases()
    },
    precautionUpdated: function (value) {
      console.log('precautionUpdated: ', +value)
      this.loadCases()
    },
    organismsUpdated: function (value) {
      this.loadCases()
    },
    resolvedUpdated: function (value) {
      this.loadCases()
    },
    confirmStatusUpdated: function (value) {
      console.log('confirmStatusUpdated:' + value)
      if (value === 0) {
        this.filterConfirmStatus = null
      } else {
        this.filterConfirmStatus = (value === 1) ? 'true' : 'false'
      }
      this.loadCases()
    },
    symptomTypeUpdated: function (value) {
      var vm = this
      var sypmtomTypeFilter = []
      if (this.symptomTypes) {
        this.symptomTypes.forEach(function (s, i) {
          if ((vm.filteredSite === 0 || vm.filteredSite === s.value) && i !== 0) {
            sypmtomTypeFilter.push(s.text)
          }
        })
      }

      this.filterSymptomTypes = sypmtomTypeFilter
      this.loadCases()
    },
    organismById: function (organId) {
      var organName = 'Not Selected'
      if (organId === 0) {
        return organName
      }

      this.organisms.forEach(function (o) {
        if (o.id === organId) {
          organName = o.name
        }
      })

      return organName
    },
    treatmentById: function (treatmentId) {
      var name = 'Not Selected'
      if (treatmentId === 0) {
        return name
      }

      this.treatments.forEach(function (t) {
        if (t.id === treatmentId) {
          name = t.displayText
        }
      })

      return name
    },
    unitById: function (unitId) {
      var unitName = ''
      this.units.forEach(function (u) {
        if (u.id === unitId) {
          unitName = u.displayText
        }
      })

      return unitName
    },
    originById: function (originId) {
      var originName = 'Not Selected'
      this.origins.forEach(function (o) {
        if (o.value === originId && o.value !== 0) {
          originName = o.label
        }
      })
      return originName
    },
    unitByName: function (unitName) {
      var unit = null
      this.units.forEach(function (u) {
        if (u.displayText === unitName) {
          unit = u
        }
      })

      return unit
    },
    precautionById: function (precautionId) {
      var name = ''
      this.precautions.forEach(function (p) {
        if (p.id === precautionId) {
          name = p.displayText
        }
      })

      return name
    },
    photosUrl: function (clientId) {
      if (this.clients[clientId].photo) {
        return '/static/' + this.clients[clientId].photo + '.png'
      }

      return '/static/user.png'
    },
    saveSymtomDetail: function (symptomDetail) {
      var vm = this
      var caseDetail = JSON.parse(JSON.stringify(symptomDetail))
      delete caseDetail.id
      caseDetail.symptoms.forEach(function (s) {
        delete s.id
      })

      var jsonData = JSON.stringify(caseDetail)
      this.$http.put(window.CONFIG.api + '/symptomDetails/' + symptomDetail.id, jsonData)
      .then(response => {
        vm.dialogFormVisible = false
        vm.selectedCase = null
        vm.loadCases()
      }, response => {
        // error
        console.log(response)
        console.log('err')
      })
    },
    reverse: function (array) {
      return array.slice().reverse()
    },
    isStaff: function (client) {
      return client.clientType === 'Staff'
    },
    exportExcel: function () {
      var loadingInstance = Loading.service({ fullscreen: true })
      console.log('exportExcel clicked')
      var unitId = this.selectedUnit
      var rUrl = window.CONFIG.api + '/symptomDetail/unit/' + unitId + '/export/excel/' + '?' + this.buildParam()

      this.$http.get(rUrl).then(response => {
        console.log(JSON.stringify(response, ' ', 2))
        var headers = response.headers.map
        var blob = new window.Blob([response.data], { type: headers['content-type'] })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'report.xls'
        link.click()
        loadingInstance.close()
      })
    },
    createNewCase: function () {
      this.newCase = {
        client: null,
        symptoms: []
      }
      this.newCaseDialogFormVisible = true
    },
    addSymptoms: function (userId, symptoms) {
      var vm = this
      var symptomList = []
      this.symptoms.forEach(function (d) {
        symptoms.forEach(function (s) {
          if (d.id === s) {
            symptomList.push(d)
          }
        })
      })

      this.newCase = {
        client: null,
        symptoms: []
      }

      var jsonData = JSON.stringify(symptomList)
      console.log(jsonData)
      this.$http.post(window.CONFIG.api + '/client/symptom/add/' + userId, jsonData)
      .then(response => {
        console.log(JSON.stringify(response, 2, ' '))
        vm.loadCases()
        this.newCaseDialogFormVisible = false
      }, response => {
      // error callback
      })
    }
  },
  mounted: function () {
    // this.loadCases()
    const end = moment().endOf('year').toDate()
    const start = moment().startOf('year').toDate()
    this.filterDateRange = [start, end]

    var vm = this

    this.$http.get(window.CONFIG.authHost + '/api/account/me').then(response => {
      console.log(JSON.stringify(response, ' ', 2))
    })

    this.$http.get(window.CONFIG.api + '/clients')
    .then(response => {
      if (response.body) {
        vm.clientList = response.body['_embedded'].clients
      } else {
        vm.clientList = []
      }

      this.loadUnits()
    }, response => {
      // error callback
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.new-case-dialog div {
    line-height: 3em;
}

.graph {
    overflow-x: scroll;
    position: relative;
    width: 100%;
    height: 450px;
    padding: 1em;
}

.graph > canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 1500px;
  pointer-events:none;
}

.el-card {
    margin-bottom: 1em;
}

.profile-photo img {
    width: 10em;
    height: 10em;
    border-radius: 50%;
    position: absolute;
    right: 2.5em;
    top: 0.5em;
}

.profile-row-photo img {
    width: 3em;
    height: 3em;
    border-radius: 50%;
}

.dialog-case-detail div {
    line-height: 3em;
}

.input-boxes {
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
}

.clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

.clearfix {
    clear: both;
}

/*.el-button {
  width: 100%;
}*/

.el-tag {
    margin-right: 0.5em;
}

.color-code-label-0 {
    width: 1em;
    height: 1em;
    background: #00D560;
    display: inline-block;
    vertical-align: middle;
    border-style: solid;
    border-width: 1px;
    border-color: lightgrey;
}
.color-code-label-1 {
    width: 1em;
    height: 1em;
    background: #0080FF;
    display: inline-block;
    vertical-align: middle;
    border-style: solid;
    border-width: 1px;
    border-color: lightgrey;
}
.color-code-label-2 {
    width: 1em;
    height: 1em;
    background: #FFDE25;
    display: inline-block;
    vertical-align: middle;
    border-style: solid;
    border-width: 1px;
    border-color: lightgrey;
}

.graph-filter > .el-radio-group {
    padding: 15px;
    float: right;
}
.graph-filter {
    margin-right: 1em;
    margin-left: 3em;
    position: absolute;
    right: 0;
    top: -0.5em;
}
.case-filter > .el-pagination {
  padding-top: 1px;
  float: right;
}
.case-filter > .case-page-size-filte {
  width: 100px;
}
.case-filter > .case-export-button {
  float: left;
  margin-right: 1em;
  margin-top: 1px;
}
.case-filter {
    margin-right: 1em;
    margin-left: 3em;
    position: absolute;
    right: 0;
    top: 0.5em;
}
.filter-title-label {
  margin-left: 2em;
  margin-right: 1em;
  text-align: right;
  line-height: 40px;
  width: 100px;
  font-size: 0.8em;
}
.filter-section > label {
  display: inline-block;
  width: 355px;
}

.filter-section .el-input {
  float: right;
  position: relative;
  width: 195px;
}

.filter-section {
  margin: 1em;
  padding-bottom: 0.7em;
  display: table-cell;
  vertical-align: middle;
  height: 50px;
  padding-top: 0.5em;
}

.filter-section label {
  text-align: right;
}

.filter-section-input {
  float: right;
}
.symptom-status-image {
  width: 36px;
  position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.symptom-detail-status-image {
  width: 36px;
  position: absolute;
  margin: auto;
  margin-left: 5px;
  top: 5px;
}
.case-note {
  max-height: 15em;
  width: 100%;
  overflow-y: scroll;
}

.dialog-case-detail div.case-note-date {
  float: right;
  padding: 1em;
  font-size: 1.0em;
  font-weight: 500;
  line-height: 1.8em;
}

.dialog-case-detail div.case-note-content {
  padding: 1em;
  border-bottom: 1px solid #EEEEEE ;
  line-height: 1.8em;
}

.case-note::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 5px;
}

.case-note::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: rgba(0,0,0,.5);
  -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}

.surveillance .el-tabs__item {
    font-size: 1em;
    padding: 0 10px 0 10px;
}

.surveillance .el-dialog.el-dialog--large {
    width: 80% !important;
}

.el-popover .el-row {
    line-height: 2.5em;
    font-family: sans-serif;
    font-size: 1.2em;
}

.el-popover .el-row .el-switch {
    float: right;
}

.dialog-footer {
    float: right;
    margin: 1em;
    margin-top: 2em;
}
</style>



// WEBPACK FOOTER //
// Surveillance.vue?75b5585a